export class MultiScaleOptionField {

  constructor(public parentIdFiled: string,
              public idField: string,
              public nameField: string) {
  }

}

